const ListingImage = ({ src, alt, type, className = "", imageHint, componentName = "ListingImage" }) => {
  const getImageUrl = (imagePath) => {
    // Handle empty/null
    if (!imagePath) {
      console.warn(`[${componentName}] No image path provided`);
      return "https://placehold.co/600x400?text=No+Image";
    }

    // ⭐ NEW: Handle array of images (take the first one)
    const path = Array.isArray(imagePath) ? imagePath[0] : imagePath;
    
    // Handle empty array or null after extraction
    if (!path) {
      console.warn(`[${componentName}] Empty image array or invalid path`);
      return "https://placehold.co/600x400?text=No+Image";
    }

    // If it's already a full URL (http/https/data), use it as-is
    if (path.startsWith('http') || path.startsWith('data:')) {
      console.log(`[${componentName}] Using full URL as-is:`, path.substring(0, 50) + '...');
      return path;
    }

    // If it starts with /images/, it's from public folder - use as-is (Vite handles it)
    if (path.startsWith('/images/')) {
      console.log(`[${componentName}] Public folder image, using as-is:`, path);
      return path;
    }

    // If it starts with /uploads/, it's from backend - add base URL
    if (path.startsWith('/uploads/')) {
      const fullUrl = `${import.meta.env.VITE_BASE_URL}${path}`;
      console.log(`[${componentName}] Backend upload, constructed URL:`, {
        originalPath: path,
        baseUrl: import.meta.env.VITE_BASE_URL,
        fullUrl: fullUrl
      });
      return fullUrl;
    }

    // Otherwise, assume it's a relative path and use as-is
    console.log(`[${componentName}] Using relative path as-is:`, path);
    return path;
  };

  // Smart alt text based on listing type
  const getAltText = () => {
    if (alt) return alt;
    if (type === 'vehicle') return 'Motor Vehicle';
    if (type === 'property') return 'Property';
    return 'Listing';
  };

  const handleError = (e) => {
    console.error(`[${componentName}] Image failed to load:`, {
      originalSrc: src,
      attemptedUrl: e.target.src,
      type: type
    });
    e.target.src = 'https://placehold.co/600x400?text=Image+Not+Found';
  };

  const handleLoad = () => {
    console.log(`[${componentName}] Image loaded successfully:`, {
      originalSrc: src,
      type: type
    });
  };

  return (
    <img 
      src={getImageUrl(src)} 
      alt={getAltText()}
      data-ai-hint={imageHint || alt || getAltText()}
      className={className}
      onError={handleError}
      onLoad={handleLoad}
    />
  );
};

export default ListingImage;